var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg9Levels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3200,
    height: 1800,
    viewBox: "0 0 3200 1800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 734.385,
    height: 24.1574,
    rx: 10,
    transform: "matrix(-1 0 0 1 2434.39 439)",
    fill: "#40B8B0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 734.385,
    height: 24.1574,
    rx: 10,
    transform: "matrix(-1 0 0 1 2579.33 603.157)",
    fill: "#FFDF3F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 734.385,
    height: 24.1574,
    rx: 10,
    transform: "matrix(-1 0 0 1 2434.38 767.314)",
    fill: "#71BC5F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 734.385,
    height: 24.1574,
    rx: 10,
    transform: "matrix(-1 0 0 1 2579.33 931.472)",
    fill: "#F4A740"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 734.385,
    height: 24.1574,
    rx: 10,
    transform: "matrix(-1 0 0 1 2434.38 1095.63)",
    fill: "#4098CE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 734.385,
    height: 24.1574,
    rx: 10,
    transform: "matrix(-1 0 0 1 2579.33 1259.79)",
    fill: "#E65A50"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 734.385,
    height: 24.1574,
    rx: 10,
    transform: "matrix(-1 0 0 1 2434.38 1423.94)",
    fill: "#A05985"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1249.91 412.24C1275.86 460.603 1272.78 583.281 1239.24 591.924C1225.87 595.371 1197.38 586.928 1168.39 569.452L1186.58 698.207H1079.12L1116.11 525.772C1095.48 501.554 1081.52 471.875 1083.85 438.62C1090.58 342.797 1223.97 363.877 1249.91 412.24Z",
    fill: "#57331F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1107.86 547.347C1094.37 487.342 1055.95 446.439 1061.82 419.62C1065.73 401.74 1076.16 390.621 1093.1 386.263C1101.86 350.816 1130.12 335.738 1177.88 341.032C1249.52 348.971 1293.24 378.721 1274.36 444.184C1257 444.184 1236.05 437.907 1207.07 448.662C1197.88 452.075 1191.3 462.657 1187.35 480.409H1174.25C1161.55 459.342 1149.02 451.601 1136.66 457.184C1124.31 462.768 1121.5 476.331 1128.24 497.874L1121.79 547.347H1107.86Z",
    fill: "#181658"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1043.3 1069.85L1205.64 1639.52L1324.08 2059.4H1410.46L1284.6 1069.85H1043.3Z",
    fill: "#0149DA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M999.885 1069.85C996.13 1363.47 983.326 1523.61 979.384 1550.29C975.442 1576.96 915.83 1746.67 800.551 2059.4H890.042C1036.8 1759.39 1118.73 1589.68 1135.82 1550.29C1152.91 1510.89 1205.65 1350.75 1285.09 1069.85H999.885Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M873.017 933.059L971.065 933.427C863.552 1175.37 807.494 1302.05 802.889 1313.46C792.528 1339.14 814.453 1378.24 823.829 1399.26C793.292 1412.92 796.545 1362.32 758.023 1380.24C722.862 1396.6 696.115 1426.24 655.491 1401.17C650.496 1398.09 645.023 1386.48 658.247 1377.42C691.192 1354.83 738.668 1315.29 745.083 1302.28C753.83 1284.53 796.475 1161.46 873.017 933.059ZM1704.61 847.382C1684.8 863.896 1664.71 882.164 1668.23 890.978C1671.76 899.791 1690.19 896.512 1693.24 910.067C1695.27 919.104 1665.37 920.573 1603.54 914.473L1460.09 971.344L1428.38 892.139L1605.16 868.024C1640.53 848.353 1673.06 835.036 1702.77 828.074C1711.13 827.83 1724.42 830.868 1704.61 847.382Z",
    fill: "#784931"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1141.58 622.09L1218.35 627.204C1237.25 798.254 1340.24 906.296 1570.81 869.72L1601.44 1089.99C1385.94 1117.85 1196.94 1031.57 1158.2 797.964C1148.18 737.491 1140.26 674.558 1141.58 622.09Z",
    fill: "#93CDC9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1103.65 599.702L1103.71 599.774L1220.02 626.412C1220.02 824.468 1282.48 951.547 1315.45 1096.79L1316.44 1101.19L1002.31 1101.19C997.88 1152.02 995.163 1204.26 993.747 1257.91H758.535C811.835 974.317 924.334 754.914 1096.03 599.702H1103.65Z",
    fill: "#9FDBD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1051.86 815.791C1043.77 940.452 1048.53 1035.59 1066.15 1101.19L1002.3 1101.19C1010.88 1002.72 1025.86 909.558 1050.21 821.703L1051.86 815.791Z",
    fill: "black",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3200,
    height: 1800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9Levels);
export default __webpack_public_path__ + "static/media/9levels.7908890b09285d888585a8dd90bf0796.svg";
export { ForwardRef as ReactComponent };